import React, { useState } from 'react';
import { Input, Button, Modal, Spin } from 'antd';
import {
  StepBackwardOutlined, CaretLeftOutlined,
  CaretRightOutlined, StepForwardOutlined,
  PlusOutlined, EditOutlined, DeleteOutlined,
  SaveOutlined, CloseOutlined, SearchOutlined,
} from '@ant-design/icons';
import { useVpApprovalPriorityForm } from './hooks/useVpApprovalPriorityForm';
import './P910JForm.css';

const P910JForm: React.FC = () => {
  const {
    mode, loading, f90j_01, f90j_11, f90j_91, f90j_92, f90j_93,
    setF90j01, setF90j11,
    navFirst, navPrev, navNext, navLast,
    startAdd, startEdit, cancel, save, doDelete,
    quickSearch, recordPosition, recordCount,
  } = useVpApprovalPriorityForm();

  const [searchKey, setSearchKey] = useState('');

  const isEditing = mode === 'add' || mode === 'edit';

  return (
    <Spin spinning={loading}>
      <div className="p910j-form">
        <h2>副總核准權限順位</h2>

        {/* Quick Search */}
        <div className="p910j-search-bar">
          <Input
            placeholder="輸入序號快速搜尋"
            value={searchKey}
            onChange={(e) => setSearchKey(e.target.value)}
            onPressEnter={() => quickSearch(searchKey)}
            style={{ width: 200 }}
            disabled={isEditing}
          />
          <Button
            icon={<SearchOutlined />}
            onClick={() => quickSearch(searchKey)}
            disabled={isEditing}
          >
            搜尋
          </Button>
          <span className="p910j-record-info">
            {recordPosition} / {recordCount}
          </span>
        </div>

        {/* Navigation */}
        <div className="p910j-nav-bar">
          <Button icon={<StepBackwardOutlined />} onClick={navFirst} disabled={isEditing}>首筆</Button>
          <Button icon={<CaretLeftOutlined />} onClick={navPrev} disabled={isEditing}>前筆</Button>
          <Button icon={<CaretRightOutlined />} onClick={navNext} disabled={isEditing}>次筆</Button>
          <Button icon={<StepForwardOutlined />} onClick={navLast} disabled={isEditing}>末筆</Button>
        </div>

        {/* Form Fields */}
        <div className="p910j-fields">
          <div className="p910j-field-row">
            <label>核准序號</label>
            <Input
              value={f90j_01}
              onChange={(e) => setF90j01(e.target.value)}
              maxLength={4}
              disabled={mode !== 'add'}
              style={{ width: 120 }}
            />
          </div>
          <div className="p910j-field-row">
            <label>員工代號</label>
            <Input
              value={f90j_11}
              onChange={(e) => setF90j11(e.target.value)}
              maxLength={8}
              disabled={!isEditing}
              style={{ width: 160 }}
            />
          </div>

          {/* Audit fields (read-only) */}
          <div className="p910j-field-row">
            <label>建立人員</label>
            <Input value={f90j_91} disabled style={{ width: 120 }} />
          </div>
          <div className="p910j-field-row">
            <label>建立日期</label>
            <Input value={f90j_92 ? f90j_92.substring(0, 10) : ''} disabled style={{ width: 140 }} />
          </div>
          <div className="p910j-field-row">
            <label>異動人員</label>
            <Input value={f90j_93} disabled style={{ width: 120 }} />
          </div>
        </div>

        {/* Action Buttons */}
        <div className="p910j-actions">
          {!isEditing ? (
            <>
              <Button type="primary" icon={<PlusOutlined />} onClick={startAdd}>新增</Button>
              <Button icon={<EditOutlined />} onClick={startEdit} disabled={recordCount === 0}>修改</Button>
              <Button
                danger
                icon={<DeleteOutlined />}
                disabled={recordCount === 0}
                onClick={() => {
                  Modal.confirm({
                    title: '確認刪除',
                    content: `確定要刪除序號 ${f90j_01} 嗎？`,
                    onOk: doDelete,
                  });
                }}
              >
                刪除
              </Button>
            </>
          ) : (
            <>
              <Button type="primary" icon={<SaveOutlined />} onClick={save}>存檔</Button>
              <Button icon={<CloseOutlined />} onClick={cancel}>還原</Button>
            </>
          )}
        </div>
      </div>
    </Spin>
  );
};

export default P910JForm;
